import {SchemaPropertyWithOptionalType} from "common/flowmaster/types/schema";

export default (type: SchemaPropertyWithOptionalType["type"]): boolean =>
  ["string", "number"].includes(Array.isArray(type) ? type[0] : type);
